import { SignupContractVersion } from '~/services/fetch-personalized-signup-contract-set-from-template';

/**
 * Check if a contract has any personalization failure (top-level or nested).
 * Top-level errors always indicate failure.
 * Nested errors indicate failure only if no PDFs are available (degraded experience).
 */
export function hasPerchPersonalizationFailure(contract: SignupContractVersion): boolean {
  if (contract.perchPersonalizedError) return true;
  const files = contract.base64PerchPersonalizedFiles;
  if (!files?.length) return false;
  if (hasAnyPerchPersonalizedPdf(contract)) return false;
  return files.some(e => e.perchPersonalizedError);
}

/**
 * Get the first personalization error from a contract (top-level or nested).
 * Used for terms blocking: block if ANY error exists, even if other files succeeded.
 */
export function getPerchPersonalizationError(contract: SignupContractVersion): string | null {
  if (contract.perchPersonalizedError) return contract.perchPersonalizedError;
  const nestedError = contract.base64PerchPersonalizedFiles?.find(
    file => !!file.perchPersonalizedError,
  )?.perchPersonalizedError;
  return nestedError ?? null;
}

/**
 * Check if any personalization PDFs exist for a contract (from any source).
 */
export function hasAnyPerchPersonalizedPdf(contract: SignupContractVersion): boolean {
  if (contract.base64PerchPersonalizedFile) return true;
  return !!contract.base64PerchPersonalizedFiles?.some(e => e.base64PerchPersonalizedFile);
}
